/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

// import moment from "moment";
import BaseObject from "@shared/BaseObject";
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import dayjs from 'dayjs'

const TIME_NOT_SET = -999999999

dayjs.extend(utc)
dayjs.extend(timezone)


export class TimeInterval extends BaseObject{


	startTime: number = 0
	endTime: number = 0
	startTimeRelative: number = 0
	endTimeRelative: number = 0
	bufferBeforeMs: number = 0
	bufferAfterMs: number = 0

	_startTimeBeforeTrim: number = 0
	_endTimeBeforeTrim: number = 0
	_alreadyTransposed: boolean = false
	_canExtendBufferAfter: boolean = true

	constructor(startTime: number = 0, endTime: number = 0, startTimeRelative: number = TIME_NOT_SET, endTimeRelative: number = TIME_NOT_SET) {
		super();
		this.startTime = startTime;
		this.endTime = endTime;
		this.startTimeRelative = startTimeRelative;
		this.endTimeRelative = endTimeRelative;
	}

	startDate() : Date{
		let date = new Date(this.startTime);
		return date
	}

	endDate() : Date{
		let date = new Date(this.endTime);
		return date
	}

	formatted(){
		let timeFormat = "hh:mma"
		let start = dayjs(this.startDate()).format(timeFormat);
		let end = dayjs(this.endDate()).format(timeFormat);
		let str = start + " - " + end;
		return str.replaceAll("m", "")
	}

	applyDate(date, moveOverDates, eventType, timezoneShift){
		this.applyDateToStart(date, moveOverDates, eventType, timezoneShift)
		this.applyDateToEnd(date, moveOverDates, eventType, timezoneShift)
	}

	applyDateToStart(date, moveOverDates, eventType, timezoneShift){
		if(this.startTimeRelative === TIME_NOT_SET || this._alreadyTransposed){
			// console.log("applyDateTo...")
			this.startTime = this.applyDateTo(date, this.startTime, moveOverDates, eventType)
		} else {
			// console.log("applyDateTo... relative")
			this.startTime = date.getTime() + this.startTimeRelative + (timezoneShift || 0)
		}
	}
	applyDateToEnd(date, moveOverDates, eventType, timezoneShift){
		if(this.endTimeRelative === TIME_NOT_SET || this._alreadyTransposed){
			// console.log("applyDateToEnd...")
			this.endTime = this.applyDateTo(date, this.endTime, moveOverDates, eventType)
		} else {
			// console.log("applyDateToEnd... relative, this.endTimeRelative = ", this.endTimeRelative)
			this.endTime = date.getTime() + this.endTimeRelative + (timezoneShift || 0)
		}
	}

	applyDateTo(date, ts, moveOverDates, eventType, momentTz){
		let tsDate = new Date(ts)
		let dateTs = date.getTime()


		let hoursUTC = tsDate.getUTCHours()
		let minutesUTC = tsDate.getUTCMinutes()

		let hours = tsDate.getHours()
		let minutes = tsDate.getMinutes()
		let seconds = tsDate.getSeconds()
		let ms = tsDate.getMilliseconds()

		let dayOffset = 0;


		let coachOffset = 0
		// let coachOffset = dayjs().tz("Europe/Berlin").utcOffset()//60

		if(eventType && moveOverDates){
			coachOffset = dayjs.tz(eventType.coachTz).utcOffset()
		}
		// console.log("coachOffset = ", coachOffset)

		//TODO this must be clientTz instead of getTimezoneOffset
		let offset = -date.getTimezoneOffset()

		let minutesUTCOffset = hoursUTC * 60 + minutesUTC

		let endOfDayMinutes = 24 * 60

		let minutesOffset = minutesUTCOffset + offset
		let minutesOffsetCoach = (minutesUTCOffset +coachOffset) % (24 * 60) + offset

		if(minutesOffsetCoach >= endOfDayMinutes + coachOffset){
			dayOffset = 1;
			minutesOffset -= endOfDayMinutes
		} else if (minutesOffsetCoach < 0 + coachOffset){
			dayOffset = -1;
			minutesOffset = (minutesOffset + endOfDayMinutes) % (24 * 60)
		}
		hours = Math.floor(minutesOffset / 60)
		minutes = minutesOffset % 60

		if(!moveOverDates){
			dayOffset = 0
		}




		let res = new Date(
			date.getFullYear(),
			date.getMonth(),
			date.getDate() + dayOffset,
			hours,
			minutes,
			seconds,
			ms
		)
		// console.log("applyDateTo: " + hours + ":" + minutes, ", offset = ", offset, ", dayOffset = ", dayOffset, ", utc = " + hoursUTC + ":" + minutesUTC + ", res = " + res, ", minutesUTCOffset = ", minutesUTCOffset, ", minutesOffset = ", minutesOffset, ", moveOverDates = ", moveOverDates, ", minutesOffsetCoach = ", minutesOffsetCoach)
		// console.log("applyDateTo: date = ", date, ", res = ", res, ", res ts = ", res.getTime(), ", tsDate.getHours() = ", tsDate.getHours())
		return res.getTime()


	}

	setRelativeTime(){
		let startOfDayTs = dayjs().startOf("day").valueOf()
		this.startTimeRelative = this.startTime - startOfDayTs;
		this.endTimeRelative = this.endTime - startOfDayTs;
		console.log("setRelativeTime: startOfDayTs = ", startOfDayTs, ", this.startTime = ", this.startTime, ", this.startTimeRelative = ", this.startTimeRelative)
	}

	toString(){
		return "{start = " + new Date(this.startTime) + "(" + this.startTime + ")" + ", end = " + new Date(this.endTime) + "(" + this.endTime + ")}"
	}

}
